// src/pages/ProviderProfileForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import BrandName from '../components/BrandName';
import './AuthPages.css';

const ProviderProfileForm = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm]     = useState({ address: '', phoneNumber: '', vehicle: '', bio: '' });
  const [saving, setSaving] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;
    setSaving(true);
    await setDoc(doc(db, 'users', user.uid), {
      address:     form.address,
      phoneNumber: form.phoneNumber,
      vehicle:     form.vehicle,
      bio:         form.bio,
    }, { merge: true });
    setSaving(false);
    navigate('/provider-dashboard');
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo"><BrandName /></div>
        <h2>Set Up Carrier Profile</h2>
        <p className="auth-sub">Tell customers about your service</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Business Address</label>
            <input className="form-input" name="address" placeholder="Your base location" value={form.address} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label className="form-label">Contact Phone Number</label>
            <input className="form-input" name="phoneNumber" placeholder="e.g. 07700 900123" value={form.phoneNumber} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label className="form-label">Vehicle Type</label>
            <select className="form-select" name="vehicle" value={form.vehicle} onChange={handleChange}>
              <option value="">Select vehicle...</option>
              <option>Small Van</option>
              <option>Large Van</option>
              <option>Pickup Truck</option>
              <option>Luton Van</option>
              <option>Skip Lorry</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">About Your Service</label>
            <input className="form-input" name="bio" placeholder="e.g. Fully licensed, 5+ years experience..." value={form.bio} onChange={handleChange} />
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={saving}>
            {saving ? 'SAVING...' : 'SAVE PROFILE'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProviderProfileForm;
